export default __webpack_public_path__ + "vignette-alpha.da0d636c.png";